import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from "i18next-http-backend";
import LanguageDetector from 'i18next-browser-languagedetector';

const utilityCloudi18n = i18next.createInstance();

utilityCloudi18n
  // detect user language.
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  .use(Backend)
  // init i18next 
  // for all options read: https://www.i18next.com/overview/configuration-options
  utilityCloudi18n.init({
    react: {
      bindI18n: 'loaded languageChanged',
      bindI18nStore: 'added',
      useSuspense: true,
    },
    lng: "en",
    fallbackLng: 'en',
     resources: {
        en: {
            translation: require('./locales/en/translation.json')
        },
        fr: {
            translation: require('./locales/fr/translation.json')
        },
    },
    ns: ['translation', 'common'],
    defaultNS: 'translation',
    backend: { loadPath: "/locales/{{lng}}/{{ns}}.json" },
    debug: false,
    interpolation: { escapeValue: false },
  }, (err, t) => {
    if (err) return console.log('something went wrong loading', err);
    t('key'); // -> same as i18next.t
  });

export default utilityCloudi18n;